import { styled } from '@linaria/react';
import { memo } from 'react';
import { locales } from '../../../../../locales/en';
import { StyledCheckmarkIcon, StyledErrorIcon, StyledErrorMessage, StyledSuccessMessage } from '../../../../common/Forms';
import { SettingsSection } from '../../../../common/Settings';
import { InlineCircularLoading } from '../../../InlineLoading';
import "./common.linaria.module.css!=!./common?./common.linaria.module.css?css=H4sIAAAAAAAAA9VWy67jNgzdz1ekiyBzgVEq2c7LAYp2102/QZBt2VYiS44kv2Lcfy/8jO14OgO0m27uDY9ISiQPSe81clCSk7KOKYti4yIIt9eCBSbufiZMgP7oBPP4mpIgYCICnjRGJi4cAU5DMxFVawKvnlQBVS68goJ6d2ZAyGnpoitI9PCz/zdYGpm66JiW188ve23Y7RyENWfaAG0qToGpUuoKKejy5lAKAzR7UhfZaXlNiIqYcGHrBjkP/xRW9UJn1W3AdMpJ5Q4P9mT5hjVPfoF9KFPFVqG5majT/cS6i4suj0cIr4aWBhDOIuH6VBiqrr7kUrk5UV8BMCTSoAU+rh7x75GSmQjAm8rr7GNas2kmz2m5rFkD/XdBTjyAlPj3IZ7BYA72yrdMGxZWwJfCUGGG4+/APf/slhRDSjduyJQ2QIZt7eqOaE3MLSGAIgHLdBvsxIaTdZOWrjObhjWBEd7zUb8X63+Vvp+gw6yVpkDXxg0y4VeTmyo72Q6t+y4jmZENTEyCvRIjWdyDm7cQuyYIScJ45e7+ksJoqhQxu2+7PynPqWE+2X3b/aEY4btvmggNNFUsHBz7Z4wSZD0stRBnbb0/dNVrVTT2QhHJcC7NuvEA4aAe2Vhn2qviuVRzJugwBNH+dBj0+RkjqB37dK/7fLl2Wm5Gf3aIrQu5FLeeaS5Ky42WnAWbrom9zBgpQHf6MZgdbhhVjiN5ODC056XziiyvcJw73Jzrri7Hw3Y4ohZGjpAZs+tZ43SnyCued6NxKAuP3TdMpJmpJ7HRZLyCiPPlMDxlBeqNp/SavDCuTsSDM/M5tDDv2TjxkAaR7ZQ4NBHj1juysB+p21tX6b3wE8yCNIycd2RhPayrzy+/JzRgZPM1ISXocrtxTjAtP+rWycV+XI4ac+5l5+Ad6cuBLNi8ZNWbfXx54/Zd5AQjqywz77YC1WPbfd+f9fKH4uh0sQ+YI3WJzQrU+7v07vYa+cU5vBR1KjUzTAqXiZgqZq5dRro4Gr1HROJb0jf8OEt6cW2zJBpEigUj0AoD2uyyLBHateB2c4TbjQW31/bA0CTlxNBVjckQ6lujv/lHnTXmjYllVcfQ/uXbPj9HV78FLF9fTy1Lf/TYuZ+1ldUV5+fGSV5hJPVDWnk9n+EteTVGpixYzuvlp0tzTBTOVe7Tci7V7WYKmKJ+yxkli3H6U4yiM4yOx4XY2RSKpG7zZ/oA33EK71hPifILS1KpDBFmUAyeGD0UDQ72QqzXS3OA283hFejZmQ6SUao7dRCRdDo8AoLtg4ZPVE8I4aJfARpnv8S09M3Zm0v12ldsq0Fno/Al/sMAbDbcxctlKhfidOHB2bpDYQHtZ7QQZwvv9Fp4ocK5rYw41JwaQxXQKfGbNQb38PzaBOaCiYgKfey+hIwiQodSJW6WplT5RNNB88QxCrUl86Kefqxq6ksREFWBxsHITBReClTC5pWlyOka1neRHzMezHNrzfOk7zG5yYU4zRNq9f8G2YL2TPAMAAA="
export const StyledIFrame = /*#__PURE__*/styled('iframe')({
  name: "StyledIFrame",
  class: "s141mvax",
  propsAsIs: false
});
export const StyledList = /*#__PURE__*/styled('ul')({
  name: "StyledList",
  class: "stij8df",
  propsAsIs: false
});
export const StyledListItem = /*#__PURE__*/styled('li')({
  name: "StyledListItem",
  class: "s14qc7fy",
  propsAsIs: false
});
export const StyledTableHeader = /*#__PURE__*/styled('span')({
  name: "StyledTableHeader",
  class: "sar7k7i",
  propsAsIs: false
});
export const StyledGridCell = /*#__PURE__*/styled('div')({
  name: "StyledGridCell",
  class: "s1dtnbzq",
  propsAsIs: false
});
export const StyledCellContent = /*#__PURE__*/styled('div')({
  name: "StyledCellContent",
  class: "syu734e",
  propsAsIs: false
});
export const accountInputStyles = "atm_bx_1owkdjb atm_c8_1m12q2r atm_cs_bfngof atm_g3_susbyh atm_l8_10s437k atm_3f_29a9wj atm_5j_1y44olf atm_vy_hv4lt8 atm_e2_14noui3 atm_1bwzkts_fowbik atm_van895_1y44olf atm_hy7ab0_1y44olf atm_pdg34x_ftgil2 atm_ypkwcm_idpfg4 atm_93q96s_llbu8d atm_l3knva_12xxubj atm_1hg7935_l1r9ht";
export const StyledIconContainer = /*#__PURE__*/styled('div')({
  name: "StyledIconContainer",
  class: "s1cw8f9w",
  propsAsIs: false
});
export const StyledGridContainer = /*#__PURE__*/styled('div')({
  name: "StyledGridContainer",
  class: "s1qgahjm",
  propsAsIs: false
});
export const formStyles = "atm_vy_1osqo2v atm_9s_1txwivl atm_ar_vrvcex atm_be_1g80g66";
export const splitGridStyles = "atm_9s_1c44wb6 atm_dz_1qred53 atm_84_ftgil2";
export const groupHeaderStyles = "atm_da_35s0z1 atm_lo_exct8b atm_le_1y44olf atm_c8_19bvopo atm_cs_1fw03zg atm_fr_v3rtn5 atm_t9_angws6 atm_7l_1fs2ovw atm_1f9w1x0_1fwxnve";
export const groupHeaderSideStyles = "atm_c8_1skhajo";
interface IValidationMessages {
  loading?: boolean;
  target?: string;
  successMessage?: string;
  messages?: any;
}
export const ValidationMessages = memo((props: IValidationMessages) => {
  const {
    loading,
    target,
    successMessage
  } = props;
  const messages = props?.messages?.[target];
  if (loading) return <span data-testid="Validation__Loading">
                <InlineCircularLoading />
            </span>;
  if (!messages) return <>
                <StyledCheckmarkIcon />{' '}
                <StyledSuccessMessage>{successMessage}</StyledSuccessMessage>
            </>;
  if (messages) {
    return <StyledList data-testid="ValidationMessages__Username">
                {messages.map((message, idx) => {
        return <StyledListItem key={idx}>
                            <StyledErrorIcon />{' '}
                            <StyledErrorMessage>{message}</StyledErrorMessage>
                        </StyledListItem>;
      })}
            </StyledList>;
  }
});
export const ModelAccountNotice = memo(() => <SettingsSection>{locales.account.performerNotice}</SettingsSection>);